import React from 'react';
import {PropagateLoader} from "react-spinners";

const Loading = ({height = 700}) => {
    return (
        <div className='inner_container'>
            <div style={{height:`${height}px`, padding:`${height*0.4}px 0`, textAlign:'center'}}>
                <p style={{marginBottom:'12px', color:'#777'}}>Loading...</p>
                <PropagateLoader color="#3e647d" cssOverride={{}}/>
            </div>

        </div>
    );
};

export default Loading;